<template>
    <div>
        <MtgCoBillRequestsListUI/>
    </div>
</template>

<script>
import MtgCoBillRequestsListUI from '../../../components/tax/MortgageCoProcessing/MtgCoBillRequestsList.vue';

export default {
  name: 'MtgCoBillRequests',
  data: () => ({

  }),
  components: {
    MtgCoBillRequestsListUI,
  },
};
</script>
